module.exports = __webpack_public_path__ + "Flag-500.1a728175af50a5bb575d8132445d7e96.svg";